import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import mainRoutes from './main-routes';
import authenticationRoutes from './authentication-routes';
import Auth0ProviderLayout from './auth0-provider';

// Fallback component for debugging
const FallbackErrorBoundary = () => {
    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Application Error</h1>
            <p>There was an error loading the application.</p>
            <p>Please check the console for more details.</p>
        </div>
    );
};

const router = createBrowserRouter([
    {
        element: <Auth0ProviderLayout />,
        children: [...authenticationRoutes, mainRoutes],
        errorElement: <FallbackErrorBoundary />,
    },
]);

export default router;
